import { Template } from "../../Template.js";

export type DecorationType = "vertical" | "vertical-1" | "rounded" | "menu" | "footer" | "none";

export const pageDecorations: Record<Template, DecorationType> = {
	[Template.Homepage]: "vertical",
	[Template.AboutUs]: "none",
	[Template.Contact]: "rounded",
	[Template.Vouchers]: "none",
	[Template.Procedure]: "none",
	[Template.ProcedureDetail]: "none",
	[Template.FrequentlyAskedQuestions]: "none",
	[Template.NotFound]: "none",
	[Template.Sitemap]: "none",
	[Template.Robots]: "none",
	[Template.Redirect]: "none",
	[Template.Blog]: "none",
	[Template.BlogDetail]: "none",
	[Template.PrivacyPolicy]: "none",
};
